export default "__VITE_ASSET__0f496b15__"